import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

export enum E {}

@Component({
  selector: 'hf-custom-radio-checks-field',
  templateUrl: './custom-radio-checks-field.component.html',
  styleUrls: ['./custom-radio-checks-field.component.scss']
})
export class CustomRadioChecksFieldComponent implements OnChanges {
  @Input() group: UntypedFormGroup;
  @Input() dataObj: E;
  @Input() type: string;
  @Input() elemId: string;

  public enumData: Array<[string, any]>;

  ngOnChanges(changes: SimpleChanges): void {
    if ('dataObj' in changes) {
      const dataObj = changes['dataObj'].currentValue;

      this.enumData = dataObj && this.parseEnum(this.dataObj);
    }
  }

  parseEnum(e: any): Array<[string, any]> {
    return e instanceof Map ? [...e.entries()] : Object.entries(e);
  }
}
